import { NotificationArgsProps } from "antd";
import React from "react";

export type NotificationPlacement = NotificationArgsProps["placement"];

export const NotificationContext = React.createContext({ name: "Default" });

export type NotificationType = 'success' | 'info' | 'warning' | 'error';
